import moment from "moment"
import { AiTwotoneHeart } from "react-icons/ai"
import { SentenceCase } from "../../utility/helper_functions"
import ImageTagsDetails from "../SocialTrendsTags/ImageTagsDetails"
import Collection from "../V2Leaderboard/Collection"
import roundtocloses0_5_value from "../V2Leaderboard/Utils/roundToClosest_0_5"
import showFloatToPercentage from "../V2Leaderboard/Utils/showFloatToPercentage"


const ImagesDiv = ({ images, type, allCollectionNames, addImageToCollection, collectionSets, fetchCollections }) => {

  return <div className="w-[30%] shrink-0 items-start justify-start align-top">
    <div className="flex flex-wrap">
      {
        images.map(image => <div className=' w-1/2 text-center max-h-96 mb-2 border-b'>
          <div className='flex  flex-col items-end ' >
            <div className="relative " data-tooltip-id={'trends-tooltip-' + (type == 'social' ? image.mediaId : image.pk)}>
              <Collection image={image} collections={allCollectionNames} addImageToCollection={addImageToCollection} collectionSets={collectionSets} fetchCollections={fetchCollections} />
              <img
                src={type == 'social' ? image.imageUrl : image.image_url}
                loading='lazy'
                className=' h-48 my-1'
              />
            </div>
            <ImageTagsDetails mediaId={image.mediaId} isretailer={type != 'social'} />
          </div>
          {
            type == 'social' ? <a className='mx-2 flex justify-evenly items-center font-bold hover:extrabold hover:underline-offset-8 hover:cursor-pointer' href={image.postUrl} target="_blank" rel="noopener noreferrer">
              <div>
                <div className='flex items-center'>{image.hasOwnProperty('countOfLikes') && parseInt(image.countOfLikes) > 3 ? <>{image.countOfLikes}<span className=' text-red-600 text-xl'><AiTwotoneHeart /></span></> : null}</div>
              </div>
              <div>
                <div className='flex items-center'>{image.username}<span className='text-xl'></span></div>
              </div>
              <div>
                {/* <div className='flex items-center'>{image.noOfComments}<span className='text-xl'><BiCommentDots /></span></div> */}
              </div>
            </a> : <a className='text-left mx-2 flex justify-evenly items-center  font-bold hover:extrabold hover:underline-offset-8 hover:cursor-pointer' href={image.postUrl} target="_blank" rel="noopener noreferrer">
              <div className="w-full pl-1">
                <div className='text-[12px] font-medium'><span className="font-semibold hidden lg:inline">Retailer : </span>{SentenceCase(image.retailer)}</div>
                {['price', 'title'].map(item => <div key={item} hidden={!image[item]} className={`font-medium ${item == 'title' ? 'text-nowrap overflow-hidden' : ''} max-w-40 text-[12px]`} style={item == 'title' ? { maxWidth: '10rem', textWrap: 'nowrap', overflow: 'hidden' } : {}}><span className="font-semibold hidden lg:inline">{SentenceCase(item)}: </span>{image[item]}</div>)}
                <div className={`flex font-medium  max-w-40 text-[12px] flex-wrap mb-1`}>
                  <span className="font-semibold hidden lg:inline text-nowrap mr-1">Product Code: </span>
                  <div className="text-end font-light">{image.pk}</div>
                </div>
                <div
                  className='text-[12px] font-medium'
                  data-tooltip-id={'forecast-tooltip-' + image.mediaId}
                >
                  Forecast Score : {<span className=" ">{roundtocloses0_5_value(showFloatToPercentage(image.fsScore))}</span>}
                </div>
              </div>
            </a>
          }

          <p hidden={type == 'retailer'} className="">{moment(type == 'social' ? image.timeStamp : image.insertDate).format("DD MMM YYYY")}</p>
        </div >)}
    </div>
  </div>
}

export default ImagesDiv
